import { Component } from '@angular/core';

@Component({
  selector: 'app-affiliate',
  imports: [],
  templateUrl: './affiliate.html',
  host: { class: 'block h-full min-h-0 w-full min-w-0 p-4' },
  styleUrl: './affiliate.css',
})
export class Affiliate {

}
